import React from 'react';

const lightingOptions = ['--', 'Dawn', 'Morning', 'Midday', 'Golden Hour', 'Dusk', 'Evening', 'Night', 'Overcast', 'Dramatic Cloudy'];
const buildingTypes = ['--', 'Residential', 'Commercial', 'Mixed-use', 'Hospitality'];
const surroundingOptions = ['--', 'Urban', 'Suburban', 'Coastal', 'Forest', 'Desert'];
const seasonOptions = ['--', 'Summer', 'Winter', 'Autumn', 'Spring'];
const skyOptions = ['--', 'Clear', 'Overcast', 'Golden hour', 'Dramatic clouds'];

const GenerationSettings = ({ settings, onSettingsChange }) => {
  const handleChange = (key, value) => {
    onSettingsChange({ ...settings, [key]: value === '--' ? '' : value });
  };

  const handleFloorsChange = (value) => {
    if (value === '') { handleChange('floors', ''); return; }
    const num = parseInt(value, 10);
    if (isNaN(num)) return;
    const clamped = Math.max(1, Math.min(200, num));
    handleChange('floors', String(clamped));
  };

  const selectClass = 'w-full glassmorphic-select rounded-2xl px-3 py-2.5 text-sm text-white bg-white/5 border border-white/10 focus:border-orange-500/50 focus:outline-none transition-all cursor-pointer';

  return (
    <div className="glassmorphic-card rounded-2xl p-4 space-y-3">
      {/* Number of Floors */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Number of Floors</label>
        <input
          type="number"
          min="1"
          max="200"
          value={settings.floors}
          onChange={(e) => handleFloorsChange(e.target.value)}
          onBlur={(e) => { if (e.target.value !== '') handleFloorsChange(e.target.value); }}
          placeholder="--"
          className="w-full glassmorphic-select rounded-2xl px-3 py-2.5 text-sm text-white bg-white/5 border border-white/10 focus:border-orange-500/50 focus:outline-none transition-all placeholder:text-white/40"
        />
      </div>

      {/* Lighting Condition */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Lighting Condition</label>
        <select
          value={settings.lighting || '--'}
          onChange={(e) => handleChange('lighting', e.target.value)}
          className={selectClass}
        >
          {lightingOptions.map((opt) => (
            <option key={opt} value={opt} className="bg-gray-900">{opt}</option>
          ))}
        </select>
      </div>

      {/* Building Type */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Building Type</label>
        <select
          value={settings.buildingType || '--'}
          onChange={(e) => handleChange('buildingType', e.target.value)}
          className={selectClass}
        >
          {buildingTypes.map((opt) => (
            <option key={opt} value={opt} className="bg-gray-900">{opt}</option>
          ))}
        </select>
      </div>

      {/* Surrounding Context */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Surrounding Context</label>
        <select
          value={settings.surrounding || '--'}
          onChange={(e) => handleChange('surrounding', e.target.value)}
          className={selectClass}
        >
          {surroundingOptions.map((opt) => (
            <option key={opt} value={opt} className="bg-gray-900">{opt}</option>
          ))}
        </select>
      </div>

      {/* Season */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Season</label>
        <select
          value={settings.season || '--'}
          onChange={(e) => handleChange('season', e.target.value)}
          className={selectClass}
        >
          {seasonOptions.map((opt) => (
            <option key={opt} value={opt} className="bg-gray-900">{opt}</option>
          ))}
        </select>
      </div>

      {/* Sky Condition */}
      <div>
        <label className="text-white/70 text-xs mb-1.5 block">Sky Condition</label>
        <select
          value={settings.sky || '--'}
          onChange={(e) => handleChange('sky', e.target.value)}
          className={selectClass}
        >
          {skyOptions.map((opt) => (
            <option key={opt} value={opt} className="bg-gray-900">{opt}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default GenerationSettings;
